import React from "react";

const Uppercase: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children
}) => {
  return <div style={{ textTransform: "uppercase" }}>{children}</div>;
};

export default Uppercase;
